import { useApplicationContext } from '../../../common/utils/applicationContext';
import { ca } from '@cian/analytics';

export const useTracking = () => {
  const { custom } = useApplicationContext();
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = custom;

  const trackShowBanner = () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'DemandCpd',
      action: 'Show_sopr',
      label: 'referral',
      page: {
        pageType: 'DemandCpdLandingPage',
        extra: {
          source,
          utm_source,
          utm_campaign,
          utm_medium,
          cpdOfferType,
        },
      },
      user: {
        userId: cianUserId,
      },
    });
  };

  const trackClickBannerBtn = () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'DemandCpd',
      action: 'click',
      label: 'referral',
      page: {
        pageType: 'DemandCpdLandingPage',
        extra: {
          source,
          utm_source,
          utm_campaign,
          utm_medium,
          cpdOfferType,
        },
      },
      user: {
        userId: cianUserId,
      },
    });
  };

  return {
    trackShowBanner,
    trackClickBannerBtn,
  };
};
